import { render, staticRenderFns } from "./createTask.vue?vue&type=template&id=c025f7a2&scoped=true&"
import script from "./createTask.vue?vue&type=script&lang=ts&"
export * from "./createTask.vue?vue&type=script&lang=ts&"
import style0 from "./createTask.vue?vue&type=style&index=0&id=c025f7a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c025f7a2",
  null
  
)

export default component.exports